import React, { memo } from 'react'

import {
  number,
  string,
  bool,
  shape,
} from 'prop-types'

import {
  noFollowingSellerAreaMockedData,
  notAvailableForHireSellerAreaMockedData,
} from 'Pods/Shared/ItemPageComponents/Mocks/sellerArea'

import SellerArea from './Components/SellerArea/SellerArea'

function SellerAreaWrapper({ sellerAreaData, extractingCoreStyles }) {
  return extractingCoreStyles ? (
    <div className="extraction-versions-wrapper">
      <SellerArea {...noFollowingSellerAreaMockedData} extractingCoreStyles />
      <SellerArea {...notAvailableForHireSellerAreaMockedData} extractingCoreStyles />
    </div>
  ) : (
    <SellerArea {...sellerAreaData} />
  )
}

SellerAreaWrapper.propTypes = {
  sellerAreaData: shape({
    designerId: number.isRequired,
    designerName: string.isRequired,
    avatarUrl: string,
    rating: number.isRequired,
    reviewsCount: number.isRequired,
    availableForHire: bool.isRequired,
  }).isRequired,
  extractingCoreStyles: bool.isRequired,
}

export default memo(SellerAreaWrapper)
